import { AuthModule, LogLevel } from "angular-auth-oidc-client";
import { environment } from "src/environments/environment";

export const authConfig = AuthModule.forRoot({
    config: {
      postLoginRoute: '/dashboard',
      forbiddenRoute: '/error/403',
      unauthorizedRoute: '/error/401',
      // silentRenewUrl: '/auth-callback',
      ignoreNonceAfterRefresh: true,
      authority: environment.AUTH_AUTHORITY,
      redirectUrl: `${window.location.origin}/emu/ui/auth-callback`,
      postLogoutRedirectUri: `${window.location.origin}/emu/ui/auth/login`,
      clientId: environment.AUTH_CLIENT_ID,
      scope: 'profile email roles openid offline_access',
      responseType: 'code',
      authWellknownEndpointUrl:
        `${environment.AUTH_AUTHORITY}/.well-known/openid-configuration`,
      silentRenew: true,
      useRefreshToken: true,
      renewTimeBeforeTokenExpiresInSeconds: 30,
      historyCleanupOff: true,
      logLevel: environment.production ? LogLevel.None : LogLevel.Debug,
      secureRoutes: [
        environment.S2EMULATOR_API_ENDPOINT,
        environment.AUTH_AUTHORITY_API,
        environment.AUTH_AUTHORITY,
      ],
    },
  });